"use strict";

var _slicedToArray = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isoCountryCodeMap = exports.countryCodeIsoMap = exports.THLegacyCountryCode = exports.isIsoCountryCode2Char = exports.TIsoCountryCode2Char = exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING = exports.storeCountryToCurrencyCodeMap = void 0;

var mapping_1 = require("../../utils/mapping");

var generated_1 = require("./generated");
/**
 * Map country to ISO numeric. Allowed inputs:
 * - Country name (title case)
 * - Country name (upper case)
 * - Country name (lower case)
 * - ISO2 (lower case)
 * - ISO2 (upper case)
 * - ISO3 (lower case)
 * - ISO3 (upper case)
 *
 * Meant to handle different input shapes since input comes from sanity
 */


exports.storeCountryToCurrencyCodeMap = _objectSpread({
  /**
   * "Great Britain" will probably not be auto generated, since "United Kingdom"
   * is the standard name
   */
  'Great Britain': 826,
  'great britain': 826
}, generated_1.storeCountryToCurrencyCodeMapGenerated);
/**
 * Maps an upper case country name to the 2-char ISO Code
 */

exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING = _objectSpread(_objectSpread({}, generated_1.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING_GENERATED), {}, _defineProperty({}, 'GREAT BRITAIN', generated_1.IsoCountryCode2Char.GB));
exports.TIsoCountryCode2Char = new mapping_1.Enum(generated_1.IsoCountryCode2Char);

function isIsoCountryCode2Char(val) {
  try {
    mapping_1.cast(val, exports.TIsoCountryCode2Char);
  } catch (err) {
    return false;
  }

  return true;
}

exports.isIsoCountryCode2Char = isIsoCountryCode2Char;
var THLegacyCountryCode;

(function (THLegacyCountryCode) {
  THLegacyCountryCode["CAN"] = "CA";
  THLegacyCountryCode["USA"] = "US";
})(THLegacyCountryCode = exports.THLegacyCountryCode || (exports.THLegacyCountryCode = {})); // provide a reverse-lookup of the same


exports.countryCodeIsoMap = new Map(Object.entries(THLegacyCountryCode).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return [value, generated_1.IsoCountryCode[key]];
})); // provide a conversion table between ISO country code values and Tim Hortons

exports.isoCountryCodeMap = new Map(Object.entries(generated_1.IsoCountryCode).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];

  return [value, THLegacyCountryCode[key]];
}));